// test659
(659 && 0);
